import Swiper from 'swiper';
import { Animation } from '../components/animation';


export function aboutUs() {
    const animation = new Animation;

    const block = window.location.hash && window.location.hash.indexOf('=') === -1 ? document.querySelector(window.location.hash) : false,
        fixidHeight = document.querySelector('[am-fixed]').clientHeight,
        headerHeight = fixidHeight > 125 ? 200 : 80,
        reg = /#command/;

    if (reg.test(window.location.hash) && block) {
        animation.scroll(block, headerHeight, 0);
    }

    if (window.innerWidth > 767) {
        return false;
    }

    const citiesWrapper = document.querySelector('.js-aboutUsCities');
    const showAllCities = document.querySelector('.js-aboutUsShowCities');

    if (!showAllCities) {
        return false;
    }

    showAllCities.addEventListener('click', () => {
        citiesWrapper.classList.toggle('is-active');
        showAllCities.classList.toggle('is-active');
        let btnText = citiesWrapper.classList.contains('is-active') ? 'Скрыть' : 'Все города';
        showAllCities.textContent = btnText;
    });

    let sliderAboutUs = new Swiper('.about-us-slider', {
        containerModifierClass: 'about-us-slider',
        wrapperClass: 'about-us-slider__wrapper',
        slideClass: 'about-us-slide',
        slideActiveClass: 'is-active',
        width: 162,
    });

    let visibleSlides = Math.floor(window.innerWidth / 162),
        maxTranslater = (visibleSlides - 1) * 162 - 560;

    sliderAboutUs.on('transitionStart', () => {
        if (sliderAboutUs.translate < maxTranslater) {
            sliderAboutUs.setTranslate(maxTranslater)
        }
    });
}